import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';

export const countrySettingsKey = ['country/settings'];

const useCountrySettings = () => useQuery({
  queryKey: countrySettingsKey,
  queryFn: () => agent.getClient()('/country/settings').then((response) => response.data),
});

export default useCountrySettings;
